import { AutogenModelInvitedCarrier, AutogenRowInvitedCarrier } from "./autogen/AutogenModelInvitedCarrier";

export class ModelInvitedCarrier extends AutogenModelInvitedCarrier<RowInvitedCarrier> {
	constructor() {
		super(RowInvitedCarrier);
	}
}

export class RowInvitedCarrier extends AutogenRowInvitedCarrier {
}